import { IComponentOptions } from "angular";
import { GamingContractDetailMachineEditComponentController } from "./controller";

export const vsComponentName = "gamingContractDetailMachineEditComponent";

export const gamingContractDetailMachineEditComponentOptions: IComponentOptions =
  {
    controller: GamingContractDetailMachineEditComponentController,
    controllerAs: "editController",
    template: require("!html-loader!./index.html").default,
    bindings: {
      selectedIds: "<",
      gridConfiguration: "<",
      contract: "<",
    },
  };
